import { createContext, useContext } from "react";

/**
 * Lets any tab open the Capture sheet (hosted by TabShell), optionally with a
 * preselected destination day. e.g. tapping a day in the Home week strip opens
 * Capture preselected to that day. Capture stays private — it only feeds the
 * signal pipeline; it never approves or shares.
 */
type CaptureCtx = {
  /** Open Capture. Pass a YYYY-MM-DD to preselect that destination day. */
  openCapture: (day?: string) => void;
};

const CaptureContext = createContext<CaptureCtx>({ openCapture: () => {} });

export function useCapture(): CaptureCtx {
  return useContext(CaptureContext);
}

export const CaptureProvider = CaptureContext.Provider;
